import React, { useEffect } from "react";
import { renderStrapiContent } from "../utils/contentfulOptions";
import FullPageLoader from "../components/FullPageLoader";
import StrapiImage from "../components/StrapiImage";
import Button from "../components/Button";
import CornerDragonfly from "../images/corner/corner-dragonfly.webp";

const TICKETS_URL = "https://www.exploretock.com/auburnroadvineyards/";

const DinnerVineyards = ({ info }) => {
  useEffect(() => {
    document.title = "Auburn Road - Dinner In The Vineyard";
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  if (!info) {
    return <FullPageLoader />;
  }

  const pageContent = info.body;
  const mainImage = info.image;
  const mainImageSrc = mainImage ? StrapiImage(mainImage) : null;
  const mainImageAlt =
    mainImage?.alternativeText || mainImage?.name || "Dinner in the vineyard";

  return (
    <>
      <img className="corner-dragonfly" src={CornerDragonfly} alt="" />
      <div className="container dinners-page p-t-100">
        <section className="dinners-hero">
          <p className="dinners-hero__kicker">Al fresco dining</p>
          <h1 className="huge-text-no-quote dinners-hero__title">
            Dinners in the Vineyard
          </h1>
          <p className="dinners-hero__intro">
            Four-course, farm-to-table dinners set among the vines, with wines
            paired by Jules and Scott & Jules joining the table.
          </p>
          <Button
            className="m-t-20"
            type="secondary"
            external
            href={TICKETS_URL}
          >
            Get Tickets
          </Button>
        </section>

        <section className="dinners-story">
          {mainImageSrc && (
            <div className="dinners-story__media">
              <img
                className="dinners-story__photo"
                src={mainImageSrc}
                alt={mainImageAlt}
              />
            </div>
          )}
          <div className="dinners-story__copy">
            {renderStrapiContent(pageContent)}
            <Button
              className="m-t-20"
              type="secondary"
              external
              href={TICKETS_URL}
            >
              Get Tickets
            </Button>
          </div>
        </section>
      </div>
    </>
  );
};

export default DinnerVineyards;
